import React from 'react';
import { Link } from 'react-router-dom';

const PlaceCard = ({ place }) => {
    const formatDescription = (description) => {
        if (!description) return 'Описание отсутствует';
        return description.length > 100 ? `${description.slice(0, 100)}...` : description;
    };

    return (
        <div className="card">
            <div className="card-content">
                <h3 className="card-title">
                    <Link to={`/place/${place.id}`} className="card-link">
                        {place.name}
                    </Link>
                </h3>
                <p className="card-description">
                    {formatDescription(place.description)}
                </p>
                <div className="card-meta">
                    <span className="meta-item">
                        <span className="icon">📍</span>
                        {place.region_name}
                    </span>
                    <span className="meta-item">
                        <span className="icon">📁</span>
                        {place.type_name}
                    </span>
                </div>
                <div className="card-actions">
                    <Link to={`/place/${place.id}`} className="btn btn-primary">
                        Узнать больше
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PlaceCard;